<template>
    <div class="phu-grid">
        <div v-for="(row, rowIndex) in slotRows" :key="rowIndex" class="phu-grid__row">
            <div
                v-for="cell in row"
                :key="cell.key"
                class="phu-grid__cell"
                :data-slot-id="cell.slot ? cell.slot.id : null"
                :data-phu-id="cell.slot ? phuId : null"
                :data-product-id="cell.slot ? cell.slot.product_id || '' : null"
                :data-fixed="cell.slot ? (locked ? '1' : '0') : null"
            >
                <slot v-if="cell.slot" :item="cell.slot"></slot>
                <div v-else class="phu-grid__empty" aria-hidden="true">
                    <i class="i-andy-close i-andy-xl"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PhuGrid',
    props: {
        slots: { type: Array, required: true },
        columns: { type: Number, required: true },
        rows: { type: Number, default: 0 },
        phuId: { type: [Number, String], default: null },
        locked: { type: Boolean, default: false }
    },
    computed: {
        sortedSlots() {
            return this.slots.slice().sort((a, b) => a.position - b.position)
        },
        slotRows() {
            const columns = Math.max(1, Number(this.columns) || 1)
            const declaredRows = Number(this.rows) || 0
            const rows = declaredRows > 0 ? declaredRows : Math.max(1, Math.ceil(this.sortedSlots.length / columns))
            const matrix = []

            for (let row = 0; row < rows; row += 1) {
                const line = []
                for (let column = 0; column < columns; column += 1) {
                    line.push({ key: `empty-${row}-${column}`, slot: null })
                }
                matrix.push(line)
            }

            this.sortedSlots.forEach((slot) => {
                const position = Number(slot.position)
                if (position < 1) {
                    return
                }
                const index = position - 1
                const row = Math.floor(index / columns)
                const column = index % columns
                if (row >= rows || column >= columns) {
                    return
                }
                matrix[row][column] = { key: slot.id, slot }
            })

            return matrix
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.phu-grid {
    @include display-flex();
    @include flex-direction(column);
    gap: $phu-gap;
    width: 100%;

    &__row {
        @include display-flex();
        @include flex-wrap(nowrap);
        gap: $phu-gap;
        width: 100%;
    }

    &__cell {
        @include display-flex();
        flex: 1 1 0;
        width: 0;
        min-width: 0;
        min-height: $phu-slot-min-height;
    }

    &__empty {
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        flex: 1 1 auto;
        width: 100%;
        min-height: $phu-slot-min-height;
        border: 1px solid $neutro-s30;
        border-radius: $phu-radius-s;
        background-color: $neutro-t80;
        color: $phu-disabled-icon;

        i {
            color: $neutro-dark;
        }
    }
}
</style>
